import BaseComponent from '../../base/base_component';
import {SYSTEM_EVENTS, USER_EVENTS} from "../../events/events";
import _ from "../../utils/underscore";
import { BaseComponentParams } from '../../base/base_component_interface';
let containerView = require('./view/container.html');
const tapSelector = '.cgp-full-screen-tap-container';

interface FullScreenTapContainerControllerParams extends BaseComponentParams {
}

class FullScreenTapContainerController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FullScreenTapContainerController';

    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-full-screen-component';

    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-full-screen';

    private _numbersOfClick = 0;

    init(params: FullScreenTapContainerControllerParams) {
        try {
            params = Object.assign({}, params, {innerHtml: containerView});
            super.init(params);
            //try to open on Game init
            _.openFullScreen();
            this._subscribe();
        } catch (e) {
            this.logger.error(`Open Full screen failed, error: ${e}`);
        }
    }


    private _subscribe() {
        this.onChildElementEvent(tapSelector, USER_EVENTS.ON_CLICK,  this._openFullScreenOnClick);
        this.onSystemEvent(SYSTEM_EVENTS.FULL_SCREEN_CHANGE, () => {
                this._handleFullScreenChangeEvent()
            }
        );
    }


    /***
     * @description On click of the tap container we will try to open the fullscreen
     * @Note     * @private
     */
    private _openFullScreenOnClick() {
        _.openFullScreen();

        //After 2 clicks on the tap container we remove to prevent the user from get stuck(in case openFullScreen is not working/supported)
        if (this._numbersOfClick > 1) {
            this.hideRootElement()
        }
        this._numbersOfClick++;
    }


    private _handleFullScreenChangeEvent(): void {

        if (_.isFullScreen()) {
            this.hideRootElement();
            this._numbersOfClick = 0;
        } else {
            this.showRootElement();
        }
    }
}

export default FullScreenTapContainerController;